import type { FeatureCollection, Point } from 'geojson';

import type { ParkAndRideFeatureProperties } from '@/types/ParkAndRideFeature';

export const parkAndRideGeoJson: FeatureCollection<Point, ParkAndRideFeatureProperties> = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [8.745366, 50.137192] },
      properties: {
        name: 'P+R-Haus Borsigallee (Station F.-Kruppstraße)',
        type: 'Parkhaus',
        spaces: 900,
      },
    },
  ],
};
